import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import {
  ButtonSize,
  ButtonState,
  ButtonType,
  UserRole,
} from '../../../../assets/types/dtoTypes';
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavContent,
} from '@angular/material/sidenav';
import {MatListItem, MatNavList} from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { UserPageComponent } from './user-page/user-page.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { CompanyPageComponent } from './company-page/company-page.component';
import { ConsultationAdminPageComponent } from './consultation-admin-page/consultation-admin-page.component';
import { SlotAdminPageComponent } from './slot-admin-page/slot-admin-page.component';
import { BroadcastEmailPageComponent } from './broadcast-email-page/broadcast-email-page.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../shared/services/authentication.service';

export type View = 'dashboard' | 'users' | 'companies' | 'consultations' | 'slots' | 'emails';

@Component({
  selector: 'app-admin-dashboard-page',
  standalone: true,
  templateUrl: './admin-dashboard-page.component.html',
  styleUrls: ['./admin-dashboard-page.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    MatNavList,
    MatIcon,
    UserPageComponent,
    DashboardPageComponent,
    CompanyPageComponent,
    ConsultationAdminPageComponent,
    SlotAdminPageComponent,
    BroadcastEmailPageComponent,
    MatListItem,
  ],
})
export class AdminDashboardPageComponent implements OnInit {

  private readonly fb = inject(FormBuilder);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);

  @ViewChildren('fileInput') fileInputs!: QueryList<ElementRef>;
  @ViewChild('usersGrowthChart') usersGrowthCanvas!: ElementRef<HTMLCanvasElement>;

  selectedView: View = 'dashboard';
  sidebarOpen = true;
  isMobile = false;
  companyForm: FormGroup;
  successMessage = '';

  filters = {
    query: '',
    role: '' as UserRole,
    status: '',
    country: '',
    languages: [] as string[],
    minSessions: 0 as number | null,
    minPositiveReviews: 0 as number | null,
  };

  protected readonly ButtonState = ButtonState;
  protected readonly ButtonType = ButtonType;
  protected readonly ButtonSize = ButtonSize;

  constructor() {
    this.companyForm = this.fb.group({
      name: ['', Validators.required],
      industry: ['', Validators.required],
      location: ['', Validators.required],
      logoUrl: [''],
      website: [''],
      description: [''],
      partnerEmail: ['', Validators.required],
      role: ['', Validators.required],
      institutionCode: [''],
    });

    this.companyForm.get('role')?.valueChanges.subscribe((role) => {
      const institutionCodeControl = this.companyForm.get('institutionCode');
      if (role === 'AGENCY') {
        institutionCodeControl?.setValidators([Validators.required]);
      } else {
        institutionCodeControl?.clearValidators();
      }
      institutionCodeControl?.updateValueAndValidity();
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth < 1024) this.sidebarOpen = false;
  }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.authenticationService.setAccessToken(token);
      this.router.navigate([], { queryParams: {}, replaceUrl: true });
    }
    this.sidebarOpen = window.innerWidth >= 1024;
  }

  select(view: View): void {
    this.selectedView = view;
  }

}
